import { getAppEndpointVersion } from 'helpers'
import { notification } from 'antd'
import axios from './axiosInstance'
import constants from '../constants'
import { handleErrors, definedErrorCodes } from '../helpers'

export default function init() {
  console.log('apps init')
}

export async function list(pageNo = 1, searchText = '', roleFilterList = '', planFilter = '') {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    return axios
      .get(
        `${constants.customerDomain}apps?per_page=${constants.perPageAppsListing}&page=${pageNo}&searchKey=${searchText}&roles=${roleFilterList}&plan=${planFilter}`,
        {
          headers: { Authorization: `Bearer ${ccBearerToken}` },
        },
      )
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        } else {
          notification.error({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}

export async function get(id) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  return axios
    .get(`${constants.customerDomain}apps/${id}`, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }

      if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      } else if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        let errorMsgs = handleErrors('')
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      }
      // } else {
      //   notification.error({
      //     message: 'Network Error',
      //     description: 'Seems to be a network error or a request timeout. Please try again.',
      //   })
      // }
      return errorObj
    })
}

export async function add(post) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps`, post, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_APP_CREATION_FAILED'
        ) {
          notification.error({
            message: 'App Creation Failed!',
            description:
              'Failed to create a new app. Please try again, contact CometChat Team if error persists.',
          })
        } else if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function update(id, post) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .put(`${ACTION_URL}apps/${id}`, post, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_APP_NOT_FOUND'
        ) {
          notification.error({
            message: 'App Not Found!',
            description: error.response.data.error.message,
          })
        } else if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_ACCESS_DENIED'
        ) {
          notification.error({
            message: 'Access denied',
            description:
              'You are not authorized to change app settings. Please contact your app owner',
          })
        } else if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        // } else {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function del(id, app) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    let ACTION_URL
    if (app.region === 'legacy') {
      ACTION_URL = constants.customerDomain
    } else {
      ACTION_URL = constants.customerDomain
    }
    const data = {
      permanent: true,
    }
    return axios
      .delete(`${ACTION_URL}apps/${id}`, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
        data,
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        // } else if (error.code === undefined && error.message) {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsUpdate(id, post, app, apiHost) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken && app.region === 'legacy') {
    let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/settings`

    return axios
      .put(`${URL}`, post, {
        headers: {
          appId: id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        // if (error.code === undefined && error.message) {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsGet(id, app) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    URL = `${URL}${app.appRegion.meta.apiHost}/${getAppEndpointVersion(app)}/settings`

    return axios
      .get(`${URL}`, {
        headers: {
          appId: id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        // if (error.code === undefined && error.message) {
        //   notification.error({
        //     message: 'Network Error',
        //     description: 'Seems to be a network error or a request timeout. Please try again.',
        //   })
        // }
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsThreadAndConversationGet(id) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    return axios
      .get(`${constants.customerDomain}apps/${id}/settings`, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function settingsThreadAndConversationMap(id, payload) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    return axios
      .post(`${constants.customerDomain}apps/${id}/settings`, payload, {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      })
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}

export async function updateSettings(id, post) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (ccBearerToken) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(
        `${ACTION_URL}apps/${id}/settings`,
        { settings: post },
        {
          headers: { Authorization: `Bearer ${ccBearerToken}` },
        },
      )
      .then(res => {
        return res.data
      })
      .catch(error => {
        if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_APP_NOT_FOUND'
        ) {
          notification.error({
            message: 'App Not Found!',
            description: error.response.data.error.message,
          })
        } else if (
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          error.response.data.error.code === 'ERR_ACCESS_DENIED'
        ) {
          notification.error({
            message: 'Access denied',
            description:
              'You are not authorized to change app settings. Please contact your app owner',
          })
        } else if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }

        let errorObject = error
        if (error.response !== undefined && error.response.data !== undefined)
          errorObject = error.response.data
        return errorObject
      })
  }
  return false
}
